function LoadScript(id, script, crossOrigin = null) {
  const existingScript = document.getElementById(id);

  if (existingScript) {
    return Promise.resolve(id, script);
  }

  const scriptElement = document.createElement("script");
  scriptElement.id = id;
  scriptElement.src = script;
  scriptElement.async = true;
  if (crossOrigin) {
    scriptElement.crossOrigin = crossOrigin;
  }

  const promise = new Promise((resolve, reject) => {
    scriptElement.addEventListener("load", () => resolve(id, script));
    scriptElement.addEventListener("error", e => reject(e));
  }).catch(e => {
    scriptElement.remove();
    throw e;
  });

  document.body.appendChild(scriptElement);

  return promise;
}

export default LoadScript;
